'use strict'

export const setSession = (key, value) => {
  sessionStorage.setItem(key, value);
}

export const getSession = (key) => {
  return sessionStorage.getItem(key);
}
/**
 * @param type year：获取当前年(2019)/ month：获取当前月日期（2019-03）/默认获取当天（2019-03-28）
 * 格式YYYY-MM-DD
 */
export const getNowFormatDate = function (pattern) {
  var date = new Date();
  return formatDate(date, pattern);
}
/**
 * 获取当前时间
 */
export const getNowTime = function () {
  var now = new Date();
  var h = now.getHours() < 10 ? '0' + now.getHours() : now.getHours();
  var m = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes();
  var s = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds();
  return h + ':' + m + ':' + s;
}


/**
 * @param pattern year:获取年格式(YYYY) ;month:获取年月格式(YYYY-MM) ;day:获取年月日格式(YYYYY-MM-DD)
 * @param type year：获取去年(2018-03-28)/ month：获取上个月（2019-02-28）/默认获取上一天（2019-03-27）
 */
export const getLastDay = function (type, pattern) {
  var date = new Date();
  var yester;
  switch (type) {
    case 'year':
      date.setFullYear(date.getFullYear() - 1);
      yester = date;
      break;
    case 'month':
      yester = new Date(date - 1000 * 60 * 60 * 24 * 30);
      break;
    default:
      yester = new Date(date - 1000 * 60 * 60 * 24);
      break;
  }
  return formatDate(yester, pattern);
}

export const getFirstDay = function (type, pattern) {
  var date = new Date();
  var yester;
  switch (type) {
    case 'year':
      date.setFullYear(date.getFullYear());
      yester = date;
      break;
    case 'month':
      yester = new Date(date - 1000 * 60 * 60 * 24 * 30*7);
      break;
    default:
      yester = new Date(date - 1000 * 60 * 60 * 24*31);
      break;
  }
  return formatDate(yester, pattern);
}




export const formatDate = function (date, pattern) {
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = '';
  switch (pattern) {
    case 'year':
      currentdate = year;
      break;
    case 'month':
      currentdate = year + seperator1 + month
      break;

    default:
      currentdate = year + seperator1 + month + seperator1 + strDate;
      break;
  }
  return currentdate;
};
export const deepClone = function(item) {
    if (!item) { return item; } // null, undefined values check

    var types = [ Number, String, Boolean ],
      result;

    // normalizing primitives if someone did new String('aaa'), or new Number('444');
    types.forEach(function(type) {
      if (item instanceof type) {
        result = type( item );
      }
    });

    if (typeof result == "undefined") {
      if (Object.prototype.toString.call( item ) === "[object Array]") {
        result = [];
        item.forEach(function(child, index, array) {
          result[index] = clone( child );
        });
      } else if (typeof item == "object") {
        // testing that this is DOM
        if (item.nodeType && typeof item.cloneNode == "function") {
          result = item.cloneNode( true );
        } else if (!item.prototype) { // check that this is a literal
          if (item instanceof Date) {
            result = new Date(item);
          } else {
            // it is an object literal
            result = {};
            for (var i in item) {
              result[i] = deepClone( item[i] );
            }
          }
        } else {
          // depending what you would like here,
          // just keep the reference, or create new object
          if (false && item.constructor) {
            // would not advice to do that, reason? Read below
            result = new item.constructor();
          } else {
            result = item;
          }
        }
      } else {
        result = item;
      }
    }

    return result;
  }

export const moveCamera = function (e, positionX, positionY) {
  let odiv = e.target;// 获取目标元素
  //计算出鼠标相对点击元素的位置,e.clientX获取的是鼠标的位置，OffsetLeft是元素相对于外层元素的位置
  let x = e.clientX - odiv.offsetLeft;
  let y = e.clientY - odiv.offsetTop;
  document.onmousemove = (e) => {
    // 获取拖拽元素的位置
    let left = e.clientX - x;
    let top = e.clientY - y;
    positionX = left;
    positionY = top;
    // 把拖拽元素 放到 当前的位置
    if (left <= 0) {
      left = 250;
    } else if (left >= document.documentElement.clientWidth - odiv.offsetWidth) {
      left = document.documentElement.clientWidth - odiv.offsetWidth - 350;
    }

    if (top <= 0) {
      top = 0;
    } else if (top >= document.documentElement.clientHeight - odiv.offsetHeight) {
      top = document.documentElement.clientHeight - odiv.offsetHeight

    }
    odiv.style.left = left + "px";
    odiv.style.top = top + "px";
    // let close_btn = document.querySelector('.videoDetails_warp .iconfont');
    // close_btn.style.left = left + 577 + "px";
    // close_btn.style.top = top + 3 + "px";
  };
  // 为了防止 火狐浏览器 拖拽阴影问题
  document.onmouseup = (e) => {
    document.onmousemove = null;
    document.onmouseup = null
  }
};

/**
 * 获取厂区列表
 * @returns {*}
 */
export const getFactoryList = function () {
  return post('php', 'general/get_factory_by_project', {});
}

/**
 * 获取配电室列表
 * @param fid 厂区id
 * @returns {*}
 */
export const getTransformmerroomListByFid = function (fid) {
  return post('php', 'curve_analysis/get_transformmerroom_by_factory', {factory_id: fid});
}
/**
 * 转场动画
 * @_this 引入页面中的this
 * @toEye 转到视角的 eye
 * @toCenter 转到视角的 center
 * @duration 动画持续时间
 * @finishFunc 动画完成时的回调函数
 */
export const transitionAnimation = function (_this, toEye, toCenter, duration, finishFunc, addFunc) {
  var __this = _this ? _this : this,
    model = __this.g3d;
  var fromEye = ht.Default.clone(model.getEye()),
    fromCenter = ht.Default.clone(model.getCenter()),
    eyeX = toEye[0] - fromEye[0],
    eyeY = toEye[1] - fromEye[1],
    eyeZ = toEye[2] - fromEye[2],
    centerX = toCenter[0] - fromCenter[0],
    centerY = toCenter[1] - fromCenter[1],
    centerZ = toCenter[2] - fromCenter[2];
  ht.Default.startAnim({
    duration,
    easing: function (e) {
      return e
    },
    finishFunc,
    action: function (e) {
      model.setEye([fromEye[0] + eyeX * e, fromEye[1] + eyeY * e, fromEye[2] + eyeZ * e]),
        model.setCenter([fromCenter[0] + centerX * e, fromCenter[1] + centerY * e, fromCenter[2] + centerZ * e]);
      if(addFunc !== undefined) {
        addFunc();
      }
    }
  });
}

/**
 * 视角连续旋转
 * @_this 引入页面中的this
 */
export const rotateView = function (_this) {
  var __this = _this ?_this : this
  __this.rotate_anim = ht.Default.startAnim({
    frames: Infinity,
    interval: 20,
    action: () => {
      __this.g3d.rotate(Math.PI/300, 0, false, false);
    }
  });
}

/**
 * 视频监控
 * @_this 引入页面中的this
 * @table 视频列表的标签名
 * @camera 所有摄像头的标签名
 * @view 摄像头视角的标签名
 * @cameras_arr 园区可用的摄像头的通道名称
 * @video_arr 园区可用摄像头的资产编号
 * @url 接口的地址
 * @tag 视频监控窗口的类名*/
export const videoMonitor = function (_this, table, camera, view, cameras_arr, video_arr, url, tag) {
  let camera_table = _this.dm.getDataByTag(table);
  let camera_info = [];
  let cameras = _this.g3d.dm().getDataByTag(camera);
  let cameras_name = cameras.getChildren()._as;
  let cameras_view = _this.g3d.dm().getDataByTag(view);
  let view_name = cameras_view.getChildren()._as;
  for(let i = 0; i < cameras_name.length; i++) {
    let obj = {"cameraNo" : cameras_name[i]._tag};
    camera_info.push(obj);
  }
  camera_table.a('ht.dataSource', camera_info);
  camera_table.a('ht.onHoverCell', function(event, cell, row, column, rowIndex, colIndex, data, view) {
    if(row) {
      for(let i = 0; i < cameras_name.length; i++) {
        if(row.cameraNo === cameras_name[i]._tag) {
          let camera = _this.g3d.dm().getDataByTag(row.cameraNo);
          let view = _this.g3d.dm().getDataByTag(view_name[i]._tag);
          camera.s('brightness', 2);
          setVisible(view, true);
        } else {
          let camera = _this.g3d.dm().getDataByTag(cameras_name[i]._tag);
          let view = _this.g3d.dm().getDataByTag(view_name[i]._tag);
          camera.s('brightness', 0.7);
          setVisible(view, false);
        }
      }
    }
  });
  camera_table.a('ht.onClickCell', function(event, cell, row, column, rowIndex, colIndex, data, view) {
    // let cameras_arr = ['D座电子楼大厅', 'D座电子楼正门（北）', '配电室、龙福宫南侧', 'D座电子楼北侧路（东）', 'D座电子楼东停车场', 'D座电子楼一层防火门', '配电室正门（西）', '锅炉房正门（西）'];
    // let video_arr = ['080100003', '080100007', '080100008', '080100002', '080100001', '080100006', '080100004', '080100005'];
    let arr = '';
    if(row) {
      for(let i = 0; i < cameras_arr.length; i++) {
        if(row.cameraNo === cameras_arr[i]) {
          arr = video_arr[i];
          _this.$get(url, [1,arr])
            .then((response) => {
              if(response.data.length !== 0){
                _this.videoPath = response.data[0].m3u8Address;
                document.querySelector(tag).style.cssText = 'display:block';
              }else{
                _this.$message({
                  type: 'error',
                  message: '暂时无法连接'
                });
              }
            }).catch((response) => {
            console.log(response);
          })
        }
      }
    }
  });
}

/**
 * 线路流动
 * @_this 引入页面中的this
 * @anim_name 动画名称
 * @tag_arr 线路标签名（数组形式）
 * @interval 动画时间
 * @uvDlt 流动长度
 * @offset_tag 流动方式
 * @action 动画启停   'move'移动 'stop'停止
 */
export const pathFlow = function (_this, anim_name, tag_arr, interval, uvDlt, offset_tag, action) {
  let offset;
  if (action == 'move') {
    _this[anim_name] = ht.Default.startAnim({
      frames: Infinity,
      interval: interval,
      action: () => {
        if (Array.isArray(tag_arr)) {
          tag_arr.forEach(function (item, index) {
            let model = _this.g3d.dm().getDataByTag(item)
            if (offset_tag === 'top.uv.offset' || offset_tag === 'all.uv.offset' || offset_tag === 'shape3d.uv.offset') {
              offset = model.s(offset_tag) || [0, 0];
              model.s(offset_tag, [
                offset[0] + uvDlt,
                offset[1]
              ]);
            } else if (offset_tag === 'offset') {
              offset = model.a("offset") || 0;
              offset = offset + uvDlt;
              if (offset > 1) {
                offset = 0;
              }
              model.a("offset", offset);
            }
          });
        }
      }
    })
  } else {
    if (_this[anim_name]) {
      _this[anim_name].stop(true);
    }
  }
}

/**
 * 透明度
 * @ node 图元节点
 * @ flag 透明或不透明
 * @ value 透明度
 */
export const setOpacity = function (node, flag, value) {
  node.s("shape3d.transparent", flag);
  node.s("shape3d.opacity", value);
}

/**
 * 设置图元的显示或者隐藏
 * @ node 图元节点
 * @ flag 显示或隐藏
 * @ empowerChildren 是否开启子节点查询（主要是用于3d场景中有block的）
 */
export const setVisible = function (node, flag, empowerChildren = false) {
  setStyle(node, "2d.visible", flag, empowerChildren);
  setStyle(node, "3d.visible", flag, empowerChildren);
}

/**
 * 设置图元的样式
 * @ node 图元节点
 * @ propertyName 属性名
 * @ propertyValue 属性值
 * @ param empowerChildren 用于判断是设置在node上还是node的孩子节点
 */
export const setStyle = function (node, propertyName, propertyValue, empowerChildren = "own") {
  if (empowerChildren === "children") {
    node.eachChild(i => {
      i.s(propertyName, propertyValue);
    });
  } else if (empowerChildren === "all") {
    node.s(propertyName, propertyValue);
    node.eachChild(i => {
      i.s(propertyName, propertyValue);
    });
  } else {
    node.s(propertyName, propertyValue);
  }
}

export const tick = function(_this, anim_name,min,max,height,tag,action){
  let foot = 30;
  if (action == 'move') {
    _this[anim_name] = ht.Default.startAnim({
      frames: Infinity,
      interval: 60,
      action: () =>{
        if(tag.length!==0) {
          tag.forEach(item => {
            let name = _this.g3d.dm().getDataByTag(item);
            let x = name.getPosition3d()[0];
            let y = name.getPosition3d()[1];
            let z = name.getPosition3d()[2];
            if (y > max) {
              foot = -height;
            }else if(y<min){
              foot = height;
            }
            y = y+ foot
            name.setPosition3d([x,y ,z])
          })
        }
      }
    })
  }else{
    if (_this[anim_name]) {
      _this[anim_name].stop(true);
    }
  }

}